import { ExportCsvButton } from "@features/AdvancedYoutubeSearch";
import { IYoutubeScrapeResponseItem } from "@shared/lib/types/influencer";
import { Table } from "@shared/ui";
import { useMemo } from "react";
import { getYoutubeSearchColumns } from "../lib/getYoutubeSearchColumns";
import styles from "./YoutubeSearchResultsTable.module.scss";

type YoutubeSearchResultsTableProps = {
  items: IYoutubeScrapeResponseItem[];
  isLoading: boolean;
};

export function YoutubeSearchResultsTable({
  items,
  isLoading,
}: YoutubeSearchResultsTableProps) {
  const columns = useMemo(() => getYoutubeSearchColumns(), []);

  return (
    <div className={styles.results}>
      <Table<IYoutubeScrapeResponseItem>
        rowKey={(record) => `${record.videoUrl}-${record.trackedQuery}`}
        columns={columns}
        dataSource={items}
        loading={isLoading && items.length === 0}
        size="small"
        className={styles.compactTable}
        pagination={false}
        scroll={{ x: 1900, y: 500 }}
        title={() => (
          <div className={styles.toolbar}>
            <span className={styles.resultCount}>
              {items.length} result{items.length === 1 ? "" : "s"}
            </span>
            <ExportCsvButton items={items} />
          </div>
        )}
      />
    </div>
  );
}
